import React from 'react';
import classNames from 'classnames';

import WpAvatar, { Size, DEFAULT_SIZE } from './WpAvatar';

import './WpAvatarGroup.scss';
import { User } from 'Shared/constants/types';

const DEFAULT_LIMIT = 3;
const DEFAULT_STACKED = true;
const DEFAULT_SHOW_ADDITIONAL_COUNT = false;

export interface Props {
  size?: Size;
  limit?: number | 'all';
  stacked?: boolean;
  showAdditionalCount?: boolean;
  popoverDetails?: Function;
  users: User[];
}

const WpAvatarGroup: React.FC<Props> = ({
  users,
  size = DEFAULT_SIZE,
  limit = DEFAULT_LIMIT,
  stacked = DEFAULT_STACKED,
  showAdditionalCount = DEFAULT_SHOW_ADDITIONAL_COUNT,
  popoverDetails,
}: Props) => {
  let usersToDisplay = users;

  if (limit !== 'all') {
    // if showAddionalCount is enabled, but we there is only 1 additional user,
    // just render the additional user's avatar instead of a +1 indicator
    const shouldSlice = (showAdditionalCount && users.length - limit > 1) || !showAdditionalCount;
    if (shouldSlice) {
      usersToDisplay = users.slice(0, limit);
    }
  }

  const additionalCount = users.length - usersToDisplay.length;
  const showAdditional = showAdditionalCount && additionalCount > 0;

  const AvatarWithDetails = popoverDetails;

  const baseClassName = 'WpAvatarGroup';
  const classes = classNames(
    baseClassName,
    `${baseClassName}--size-${size}`,
    stacked ? `${baseClassName}--stacked` : false,
    AvatarWithDetails ? `${baseClassName}--z-hover` : false
  );

  return (
    <div className={classes}>
      {showAdditional && <div className={`${baseClassName}__additional-count`}>+{additionalCount}</div>}
      {usersToDisplay?.reverse().map(user => {
        if (AvatarWithDetails) {
          return (
            <AvatarWithDetails user={user} key={user.id}>
              <WpAvatar avatar={user.avatar} size={size} disabled={user.disabled} />
            </AvatarWithDetails>
          );
        } else {
          return <WpAvatar avatar={user.avatar} size={size} key={user.id} disabled={user.disabled} />;
        }
      })}
    </div>
  );
};

export default WpAvatarGroup;
